<template>
  <div class="props">
    <div class="list" v-show="!S_GlobalSearch">
      <ul v-show="stage === 'outer'" class="outer-data">
        <li v-if="!outerDataLoading && (!outerData || !outerData.length)">
          空空如也~
        </li>
        <li v-if="outerDataLoading" v-loading="outerDataLoading"></li>
        <li class="cate-item" :data-key="i" v-for="(item, i) in outerData">
          <div
            class="cate-item__header"
            @click="gotoInner(item.cate, i)"
            :data-corner-mark="item.cornerMarkType || 'none'"
          >
            <span class="title">
              <!-- :src="`/static/svg/right-nav-new/${item.cate.name}.svg`" -->
              <img
                :src="$handleAssetsUrl(item.cate.iconUrl)"
                :style="{
                  maxWidth: '18px',
                  maxHeight: '16px',
                  marginRight: '6px',
                }"
              />
              <span
                class="ellipsis-x"
                :style="{
                  position: 'relative',
                  maxWidth: '200px',
                  whiteSpace: 'nowrap',
                  textAlign: 'left',
                }"
              >
                {{ item.cate.name }}
                <template v-if="item.cate.cornerMarkType">
                  <MyLabel
                    :css="{
                      position: 'absolute',
                      top: '-4px',
                      left: '102%', //`${item.cate.name.indexOf('G') > -1 ? item.cate.name.length * 14 - 14 + 3 : item.cate.name.length * 14 + 3}px`
                    }"
                    :text="item.cate.cornerMarkType === 1 ? 'NEW' : '上新'"
                  ></MyLabel>
                </template>
              </span>
            </span>
            <span class="more">更多{{ ">" }}</span>
          </div>
          <div class="cate-item__content" v-if="item && item.items">
            <div
              class="sprite-item item"
              :class="{ isPreview: i === 4 }"
              v-for="(itemL, indexL) in item.items"
              :key="indexL"
              @mouseenter="
                loadLottie(
                  itemL,
                  { index: indexL, id: 'props_' + item.id },
                  true
                )
              "
              @mouseleave="
                loadLottie(
                  itemL,
                  { index: indexL, id: 'props_' + item.id },
                  false
                )
              "
              @click="
                slidAddSprites(itemL);
                materialPushAnalysis({
                  type: 'props',
                  id: item.id,
                  name: item.name,
                  itemType: itemL.fileType,
                });
              "
            >
              <img
                v-if="itemL.fileType !== 42"
                :class="{ Imglottie: itemL.fileType === 5 }"
                :src="$handleAssetsUrl(itemL.thumbnailUrl)"
                width="auto"
                height="100%"
              />

              <video
                v-if="itemL.fileType == 42"
                :src="$handleAssetsUrl(itemL.thumbnailUrl)"
                width="auto"
                height="100%"
                loop="loop"
              ></video>
              <div
                class="mask"
                :class="{
                  Clottie: itemL.fileType === 5,
                  ['props_' + item.id]: true,
                }"
                :ref="'props_' + item.id"
                :data-ref="'props_' + item.id"
              ></div>

              <span v-if="itemL.fileType == 42" class="videoIcon"></span>

              <!-- <vipLabel :payType="itemL.payType" :itemData="itemL" :boxName="boxName" /> -->
              <payType-subscript
                :item="itemL"
                style="right: 4px; bottom: 4px; z-index: 6"
              ></payType-subscript>

              <el-tooltip
                effect="dark"
                content="收藏"
                placement="top"
                :open-delay="1000"
              >
                <i
                  class="collection_sprite_icon"
                  :class="[
                    {
                      collection_sprite_icon_active:
                        /*itemL.favorites*/ itemL.favorites,
                    },
                    'vipResource_' + itemL.id,
                  ]"
                  @mouseover="
                    collectionSpriteIconTit($event);
                    stopDocument($event);
                  "
                  @click="
                    stopDocument($event);
                    collectionSpriteIconFS(itemL, $event);
                  "
                ></i>
              </el-tooltip>
            </div>
          </div>
        </li>
      </ul>
      <div v-show="stage === 'inner'" class="inner-data">
        <div class="inner-data__header">
          <i class="back" @click="gotoOuter()"></i>
          <img
            :src="`/static/svg/right-nav-new/${
              (category[outerSelectCateIndex] || {}).name
            }.svg`"
            class="icon"
            alt
          />
          <span
            class="title ellipsis-x"
            style="position: relative; maxwidth: 224px; width: auto"
          >
            {{ (category[outerSelectCateIndex] || {}).name }}
            <template
              v-if="(category[outerSelectCateIndex] || {}).cornerMarkType"
            >
              <MyLabel
                :css="{
                  position: 'absolute',
                  top: '-4px',
                  left: '102%',
                }"
                :text="
                  (category[outerSelectCateIndex] || {}).cornerMarkType === 1
                    ? 'NEW'
                    : '上新'
                "
              ></MyLabel>
            </template>
          </span>
        </div>
        <cate-menu
          v-if="innerCates && innerCates.length"
          :options="innerCates"
          :selectedIndex="selectedCateIndex"
          @clickItem="updateCateIndex"
        ></cate-menu>
        <div class="menu-wrapper" v-show="slideState && dataMsg == 'props'">
          <div class="backdrop">
            <i @click="gotoOuter()"></i>
          </div>
          <MyMenu
            v-if="innerCates && innerCates.length"
            :options="innerCates"
            :selectedIndex="selectedCateIndex"
            @clickItem="updateCateIndex"
            :myStyle="{
              width: '240px',
              zIndex: '300px',
            }"
          ></MyMenu>
        </div>
        <!-- inner list -->
        <div
          class="body-list"
          :style="{
            width: '270px',
            //'height': (innerData.length ? (scollTop.material * Math.ceil(innerData.length/scollTop.rowNum) + 100 + 'px') : '200px'),
            // --每个slide文件都会有注释这个css属性，禁止分组图固定在素材栏上方--
            // 'margin-top': fixTopId.id === ('_' + item.id) ? '120px' : '0px',
            // ----
            //'padding-top' : (innerData.length ? (scollTop.material * Math.ceil(innerData.length/scollTop.rowNum) - 10 + 'px') : '50px'),
            'min-height': '270px',
            paddingBottom: '100px',
            'justify-content': 'space-between',
          }"
        >
          <switchChartType
            chartFrom="rightNav"
            v-show="isShowChart"
            :showMark="true"
          ></switchChartType>
          <!-- v-if="outerSelectCateIndex > -1 && dataArray['_' + (category[outerSelectCateIndex] || {}).id]"
          v-for="(itemL, indexL) in (dataArray['_' + (category[outerSelectCateIndex] || {}).id] || {}).data"-->
          <div
            v-if="innerData && innerData.length"
            v-for="(itemL, indexL) in innerData"
            class="item"
            :class="{ isPreview: itemL.fileType === 8 }"
            @mouseenter="
              loadLottie(
                itemL,
                { index: indexL, id: 'props_inner_' + activeCate.id },
                true
              )
            "
            @mouseleave="
              loadLottie(
                itemL,
                { index: indexL, id: 'props_inner_' + activeCate.id },
                false
              )
            "
            :key="itemL.id + outerSelectCateIndex + indexL"
            @click="
              slidAddSprites(itemL);
              materialPushAnalysis({
                type: 'props',
                id: activeCate.id,
                name: activeCate.name,
                itemType: itemL.fileType,
              });
            "
            :style="{
              position: 'relative',
              marginBottom: '16px',
              //top : itemL.topWFC + 'px',
              //left: itemL.leftWFC + 'px'
            }"
          >
            <img
              v-if="itemL.fileType !== 42"
              :class="{ Imglottie: itemL.fileType === 5 }"
              :src="$handleAssetsUrl(itemL.thumbnailUrl)"
              width="auto"
              height="100%"
            />

            <video
              v-if="itemL.fileType == 42"
              :src="$handleAssetsUrl(itemL.thumbnailUrl)"
              width="auto"
              height="100%"
              loop="loop"
            ></video>
            <div
              class="mask"
              :class="{ Clottie: itemL.fileType === 5 }"
              :ref="'props_inner_' + activeCate.id"
            ></div>

            <span v-if="itemL.fileType == 42" class="videoIcon"></span>

            <!-- <vipLabel :payType="itemL.payType" :itemData="itemL" :boxName="boxName" /> -->
            <payType-subscript
              :item="itemL"
              style="right: 4px; bottom: 4px; z-index: 6"
            ></payType-subscript>

            <el-tooltip
              effect="dark"
              content="收藏"
              placement="top"
              :open-delay="1000"
            >
              <i
                class="collection_sprite_icon"
                :class="[
                  { collection_sprite_icon_active: itemL.favorites },
                  'vipResource_' + itemL.id,
                ]"
                @mouseover="
                  collectionSpriteIconTit($event);
                  stopDocument($event);
                "
                @click="
                  stopDocument($event);
                  collectionSpriteIconFS(itemL, $event);
                "
              ></i>
            </el-tooltip>
          </div>
        </div>
        <div
          v-if="
            !innerDataLoading &&
            (!innerData || !innerData.length) &&
            !isShowChart
          "
        >
          空空如也~
        </div>
        <div
          class="prop-inner-loading"
          v-loading="outerDataLoading || innerDataLoading"
        ></div>
      </div>
    </div>
    <div v-show="S_GlobalSearch">
      <Search
        :boxName="boxName"
        :dataMsg="dataMsg"
        v-on:addsprite="slidAddSprites"
        :searchDataArray="dataArray"
        :loading="loading"
      ></Search>
    </div>
    <div class="more-props" v-show="slideState && dataMsg == 'props'">
      <div class="btn" @click="callSpriteLib()">更多道具</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import rightnavSlide from "../../mixins/rightnavSlide";
import Search from "./search/search";
import CateMenu from "../controls/cateMenu";
import MyMenu from "../controls/menu";
import map from "lodash/map";
import switchChartType from "../../popups/content/switchChartType";
import MyLabel from "../../widgets/label";
import PayTypeSubscript from "@/components/common/materialPayTypeSubscript";

export default {
  mixins: [rightnavSlide],
  components: {
    Search,
    CateMenu,
    MyMenu,
    switchChartType,
    MyLabel,
    PayTypeSubscript,
  },
  props: {
    dataMsg: {
      type: String,
    },
  },
  data() {
    return {
      boxName: "props", // 素材盒子的名字
      dataArray: [], // 数据数组
      dataSet: {
        // 请求数据对象
        pIndex: 0,
        type: 17,
        sOfPage: 24,
        fPage: 24,
        style: null,
      },
      scollTop: {
        // 控制滚动条的数据
        default: 22, // 默认添加的高度
        Incremental: 140, // 单个分类的高度
        material: 110, // 单个元素的高度
        materialW: 94, // 单个元素的宽
        rowNum: 3, // 每行个数
      },
      waterfallComputeData: {
        // 瀑布流的数据
        listNum: 3, // 瀑布流的列数
        default: 20,
      },
      stage: "outer",
      outerSelectCateIndex: -1,
      innerData: [],
      outerData: [],
      innerCates: [],
      selectedCateIndex: -1,
      isShowFixedMenu: false,
      outerDataLoading: false,
      innerDataLoading: false,
      isShowChart: false,
      currentPage: 1,
      pagesEnd: false,
    };
  },
  computed: {
    ...mapGetters([
      "TopNav_Size",
      "MaterialPane_Size",
      "Window_Size",
      "StyleMsg",
      // "RightNavTopPartHeight"
    ]),
    activeCate() {
      return this.category[this.outerSelectCateIndex] || {};
    },
    // innerData () {
    //   return (this.dataArray['_' + (this.category[this.outerSelectCateIndex] || {}).id] || {}).data || [];
    // }
  },
  watch: {
    dataMsg(val) {
      if (val === "props") {
        this.handleMenuPosition();
        // this.getCategory();
      }
    },
    "MaterialPane_Size.width"(val) {
      if (val > 95 && this.dataMsg === "props") {
        this.getOuterData();
      }
    },
    category(val) {
      this.getOuterData();
    },
    loading(val) {
      this.innerDataLoading = val;
    },
  },
  mounted() {
    this.$bus.on("upload_vue", (data) => {
      let dataData = data.data || {};
      // 上传完成的发出事件
      if (
        data.type === "image" &&
        data.data != null &&
        (data.name === "imagePicTwo" ||
          // data.name === 'imagePic' ||
          data.name === "imageFrame" ||
          data.name === "gif")
      ) {
        let files = data.file;
        if (files.length) {
          files = Array.from(data.file);
        }

        let scenesData = {},
          PushUrl = "/api/user/pic";

        scenesData.fileType = 3;
        if (data.name === "gif") {
          scenesData.fileType = 34;
        }
        if (
          (data.data && data.data.length == null) ||
          (data.data.length && data.data.length == 1) ||
          data.name === "gif"
        ) {
          if (!(data.name === "gif")) {
            data.data = data.data[0];
          }
          scenesData.url = (data.data || dataData).filename;
          scenesData.title = data.fileName || data.title;
          scenesData.thumbnailUrl = (data.data || dataData).thumbnailName;

          // if (data.name != "imageFrame") {
          //   this.slidAddSprites({
          //     id: null,
          //     url: scenesData.url,
          //     fileType: null,
          //   });
          // }
        } else {
          PushUrl = "/api/user/pic/multiples";
          scenesData.url = "";
          scenesData.title = "";
          scenesData.thumbnailUrl = "";
          for (let j = 0; j < data.data.length; j++) {
            let comma = ",";
            if (j == data.data.length - 1) {
              comma = "";
            }
            scenesData.url += data.data[j].filename + comma;
            scenesData.title += data.data[j].title + comma;
            scenesData.thumbnailUrl += data.data[j].thumbnailName + comma;
          }
        }
        this.materialPushAnalysis({ type: "imgSpritesUpload" });

        this.$http
          .post(PushUrl, scenesData)
          .then((resScenes) => {
            let category = "collectPic";
            if (data.name === "gif") {
              category = "collectGif";
            }
            this.$bus.emit("collectPersonal_vue", { data: category });

            let m = resScenes.data.data;
            if (m && !m.length && data.name != "imageFrame") {
              this.slidAddSprites({
                id: m.id,
                url: scenesData.url,
                fileType: m.fileType,
                isPrivate: true
              });
            }

            // 处理用户自定义文件夹
            if (this.dataMsg === "personal") {
              let materials = resScenes.data.data || [];
              if (PushUrl === "/api/user/pic/multiples") {
                materials = map(materials, (v) => v);
                [].concat(materials).forEach((v, i) => {
                  sensors.track("materialUpload", {
                    material_id: v,
                    material_size: (files[i].size / 1024 / 1024).toFixed(4),
                    material_type: "图片",
                  });
                });
              } else {
                let v = materials;
                let size = materials.size;
                sensors.track("materialUpload", {
                  material_id: v.id,
                  material_size: (size / 1024 / 1024).toFixed(4),
                  material_type: "图片",
                });
              }
              this.$bus.emit("relateMaterialDone", {
                materials: [].concat(materials),
                materialTypeName: "pic",
                multi: PushUrl === "/api/user/pic/multiples",
              });
            }
          })
          .catch((Serror) => {
            console.log(Serror, "失败");
          });
      }
    });

    $(window).on("scroll", this.handleMenuPosition);
    this.$bus.on("rightSlideBoxBroadcast_vue", this.handleMenuPosition);
    this.$bus.on("rightSlideBoxBroadcast_vue", ({ el } = {}) => {
      const { dataMsg, stage, selectedCateIndex } = this;
      if (
        dataMsg === "props" &&
        stage === "inner" &&
        // selectedCateIndex === -1 &&
        !this.innerDataLoading &&
        !this.pagesEnd
      ) {
        if (el.scrollTop + el.offsetHeight > el.scrollHeight - 10) {
          this.getCategoryList(-1, this.currentPage + 1, {sameCateIndex: true});
        }
      }
    });
  },
  methods: {
    getOuterData() {
      this.outerData = [];
      let tasks = [];
      let draftId = window.location.hash.slice(2);
      this.outerDataLoading = true;
      this.category.forEach((v, i) => {
        this.outerData.push({
          id: v.id,
          cate: v,
        });
        let task = this.$http
          .get("/api/common/material", {
            params: {
              pIndex: 1,
              sOfPage: 3,
              fPage: 3,
              type: v.originalType ? v.originalType : 17,
              style: this.StyleMsg,
              category: v.id,
              draftId,
            },
          })
          .then((res) => {
            this.$set(this.outerData[i], "items", res.data.data);
          })
          .catch((err) => console.warn(err))
          .finally(() => {
            return Promise.resolve();
          });
        tasks.push(task);
      });

      Promise.all(tasks)
        .then(() => {
          this.outerDataLoading = false;
        })
        .catch((err) => {
          this.outerDataLoading = false;
        });
    },
    getCategory() {
      this.stage = "outer";
      return this.$http
        .get("/api/home/category", {
          params: {
            type: 17,
            style: this.StyleMsg,
          },
        })
        .then((res) => {
          return res.data.data;
        })
        .catch((err) => []);
    },
    gotoInner(item, i) {
      this.materialLib_Nav_Param.classify = item.id;
      this.outerSelectCateIndex = i;
      this.selectedCateIndex = -1;
      this.innerData = [];
      this.getInnerCategories(item.id, item.originalType);
      // this.getInnerData({
      //   cateId: item.id,
      //   originalType: item.originalType
      // });
      this.getCategoryList(-1);
      this.stage = "inner";
      this.isShowChart = false;
      this.$nextTick(() => {
        this.handleMenuPosition();
      });
      const scrollWrapper = this.$parent.$refs.slidesDOM;
      this.memoScrollTop = scrollWrapper.scrollTop;
    },
    // getInnerData ({
    //   cateId,
    //   originalType,
    //   pIndex = 1
    // } = {}) {
    //   let draftId = window.location.hash.slice(2);
    //   this.innerDataLoading = true;
    //   return this.$http.get('/api/common/material', {
    //     params: {
    //       pIndex,
    //       sOfPage: 24,
    //       fPage: 24,
    //       type: originalType ? originalType : 17,
    //       style: this.StyleMsg,
    //       category: cateId,
    //       draftId
    //     }
    //   })
    //     .then(res => {
    //       this.innerCateListSize = res.data.total;
    //       this.innerData = res.data.data;
    //       this.innerDataLoading = false;
    //     })
    //   // this._getData(cateId);
    // },
    gotoOuter() {
      this.materialLib_Nav_Param.classify = null;
      this.stage = "outer";
      this.outerSelectCateIndex = -1;
      const scrollWrapper = this.$parent.$refs.slidesDOM;
      scrollWrapper.scrollTop = this.memoScrollTop;
    },
    getActiveCate() {
      return this.category[this.outerSelectCateIndex] || {};
    },
    getInnerCategories(cateId, originalType) {
      return this.$http
        .get("/api/home/category", {
          params: {
            type: originalType ? originalType : 17,
            style: this.StyleMsg,
            categoryId: cateId,
          },
        })
        .then((res) => {
          this.innerCates = map(res.data.data, (v) => v);
        })
        .catch((err) => {
          this.innerCates = [];
        });
    },
    async updateCateIndex (...args) {
      $('.secondMenuPane .slides')[0].scrollTop = 0;
      this.$nextTick(() => {
        this.getCategoryList(...args);
      })
    },
    getCategoryList(index, pIndex = 1, {sameCateIndex} = {}) {
      if (!sameCateIndex) {
        this.selectedCateIndex = index;
      }
      let cate = this.innerCates[this.selectedCateIndex] || {};
      let cateId = cate.id || this.activeCate.id;
      let draftId = window.location.hash.slice(2);
      let originalType = this.activeCate.originalType;
      this.isShowChart = false;
      this.innerDataLoading = true;

      this.materialLib_Nav_Param.category = cateId; //记录分类id，打开模板素材库时需要使用
      if (pIndex === 1) {
        this.pagesEnd = false;
      }
      return this.$http
        .get("/api/common/material", {
          params: {
            pIndex,
            sOfPage: 24,
            fPage: 24,
            type: originalType ? originalType : 17,
            style: this.StyleMsg,
            category: cateId,
            draftId,
          },
        })
        .then((res) => {
          this.innerData =
            pIndex === 1
              ? res.data.data
              : [].concat(this.innerData, res.data.data);
          this.currentPage = pIndex;
          if (cate.name === "智能图表" && res.data.total === 0) {
            this.isShowChart = true;
          }

          if (this.innerData.length >= res.data.data) {
            this.pagesEnd = true;
          }

          this.innerDataLoading = false;
        })
        .catch(() => {
          this.innerDataLoading = false;
        });
    },
    handleMenuPosition() {
      let menuWrapper = $(this.$el).find(".menu-wrapper");
      let rect = menuWrapper[0].getBoundingClientRect();
      let menu = menuWrapper.find(".menu");
      let backdrop = menuWrapper.find(".backdrop");
      let calcTop = 150 - document.documentElement.scrollTop;
      if (rect.top < 150) {
        menuWrapper.css({
          width: "auto",
          height: "38px",
          overflow: "visible",
        });
        menu.css({
          position: "fixed",
          top: calcTop + "px",
          left: "82px",
          width: "240px",
        });
        backdrop.css({
          position: "fixed",
          top: calcTop + "px",
          left: "82px",
        });
      } else {
        menuWrapper.css({
          width: 0,
          height: 0,
          overflow: "hidden",
        });
        menu.css({
          position: "relative",
          top: 0,
          left: "82px",
          width: "270px",
        });
        backdrop.css({
          position: "absolute",
          top: 0,
          left: "82px",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
props {
  width: 270px;
}

.cate-item {
  &__header {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 270px;
    height: 38px;
    padding-right: 14px;
    padding-left: 14px;
    background-color: #f6f6fb;
    border-radius: 8px;
    cursor: pointer;
    & .title {
      display: flex;
      align-items: center;
      //font-weight: bold;
      max-width: 208px;
      & > i {
        width: 22px;
        height: 20px;
        margin-right: 8px;
        background-image: url(../../../../static/svg/right-nav-new/创意相框.svg);
        background-repeat: no-repeat;
      }
    }
    & .more {
      flex-shrink: 0;
      color: #474261;
      transform: scale(.9);

      &:hover {
        color: #5778fb;
      }
    }
  }
  &__content {
    display: flex;
    justify-content: space-between;
    width: 270px;
    padding-top: 14px;
    padding-bottom: 20px;
  }
}
.sprite-item {
  width: 80px;
  height: 80px;
  background-color: #eaeaf5;
}

.inner-data {
  &__header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 270px;
    height: 38px;
    padding-right: 10px;
    padding-left: 10px;
    margin-bottom: 16px;
    background-color: #f6f6fb;
    border-radius: 8px;

    & .back {
      width: 18px;
      height: 16px;
      margin-right: 8px;
      background-image: url(../../../../static/svg/right-nav-new/back.svg);
      background-repeat: no-repeat;
      cursor: pointer;
    }
    & .icon {
      max-width: 22px;
      max-height: 20px;
      margin-right: 8px;
    }
    & > .title {
      width: 224px;
      text-align: left;
    }
  }
}
.outer-data {
  padding-bottom: 100px;
}

.body-list {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  min-height: 88px;
  margin-top: 15px;
  & .item.isPreview:hover {
    & > img {
      display: none;
    }
  }
}
.item {
  position: absolute;
  overflow: hidden;
  width: 80px;
  height: 85px;
  background-color: #fafafd;
  border: solid 2px #dbdff0;
  border-radius: 3px;
  cursor: pointer;

  &.sprite-item {
    position: relative;
    top: 0;
    left: 0;
  }

  &.isPreview:hover {
    & > img {
      display: none;
    }
  }

  &:hover {
    border-color: #5778fb;
    .mask,
    .Clottie {
      z-index: 5;
      opacity: 1;
    }
     > .Imglottie {
      z-index: 0;
      opacity: 0;
    }
    .modify {
      opacity: 1;
    }
    .videoIcon {
      opacity: 1 !important;
    }
  }

   > video,
   > img {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 5;
    width: auto;
    max-width: 100%;
    height: auto;
    max-height: 100%;
    margin: auto;
  }

  .videoIcon {
    position: absolute;
    top: 3px;
    left: 3px;
    z-index: 10;
    width: 24px;
    height: 24px;
    background-color: rgba(0, 0, 0, .6);
    background-image: url("../../../../static/svg/soundSpriteIcon.gif");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 13px 13px;
    border-radius: 100%;
    opacity: 0;
  }

  .mask,
  .Clottie {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
    transition: all .3s;
    opacity: 0;
  }

  .modify,
  .label {
    position: absolute;
    right: 5px;
    bottom: 5px;
    z-index: 8;
    width: 30px;
    height: 18px;
    color: #fff;
    line-height: 18px;
    background: #d83d60;
    border-radius: 5px;
  }
  .modify {
    width: 35px;
    height: 35px;
    background-image: url("../../../../static/svg/edit-display-white.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 20px 18px;
    transition: all .3s;
    cursor: pointer;
    opacity: 0;
  }
}

@import "./slide.scss";
.more-props {
  position: fixed;
  bottom: 0;
  z-index: 300;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 270px;
  height: 90px;
  text-align: center;
  pointer-events: none;
  & > .btn {
    @include bottom-more-btn();
    pointer-events: all;
  }
}

.menu-wrapper {
  position: relative;
  z-index: 300;
  height: 38px;

  & .backdrop {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    box-sizing: content-box;
    width: 270px;
    height: 38px;
    padding-bottom: 15px;
    background-color: #fff;

    & > i {
      width: 23px;
      height: 23px;
      background-image: url(../../../../static/svg/right-nav-new/close.svg);
      background-repeat: no-repeat;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/rightnav/slide/props.vue